export type BookingOffering = {
  id: string;
  name: string;
  revision: string;
  service_revision: string;
  price: string;
  currency: string;
  estimated_minutes: number;
  tax_mode: string;
  tax_rate: string;
  tax_label: string | null;
};
export type BookingServiceDraft = {
  selected: string;
  offering_id: string;
  offering_revision: string;
  service_revision: string;
  quantity: string;
  terms: Omit<BookingOffering, "id" | "revision" | "service_revision">;
  review_required: boolean;
};
export function serviceDraft(offering: BookingOffering): BookingServiceDraft {
  const { id, revision, service_revision, ...terms } = offering;
  return {
    selected: "0",
    offering_id: id,
    offering_revision: revision,
    service_revision,
    quantity: "1",
    terms,
    review_required: false,
  };
}
export function reconcileServiceDrafts(
  drafts: BookingServiceDraft[],
  offerings: BookingOffering[],
) {
  const saved = new Map(drafts.map((line) => [line.offering_id, line]));
  const available = new Set(offerings.map((offering) => offering.id));
  return {
    services: offerings.map((offering) => {
      const line = saved.get(offering.id);
      if (!line) return serviceDraft(offering);
      return {
        ...line,
        terms: line.terms || serviceDraft(offering).terms,
        review_required:
          line.offering_revision !== offering.revision ||
          line.service_revision !== offering.service_revision,
      };
    }),
    removed: drafts
      .filter(
        (line) => line.selected === "1" && !available.has(line.offering_id),
      )
      .map((line) => line.terms?.name || line.offering_id),
  };
}
